/*
Component Name: Dashboard component
Contains : DashHeader, DashboardMain, BuildPlanScreen
Imcludes : Services for custom calander
Default screen: Dashboard
*/
import React, { Component } from 'react';
import { getSelectedWeekDates, getWeekDays, formatTimeStamp, getTimeStamp, compareRecipeTime, sortByKey, differnceTimeStamp, validateInputs } from 'lib/services';
import moment from 'moment'
import { post, put, delet, get } from 'lib/api'
import RoutingConstants from 'lib/RoutingConstants'
import Loader from 'lib/loader';
import ReactResizeDetector from 'react-resize-detector';
import { browserName } from 'react-device-detect';
import _ from 'lodash'
import DashHeader from './DashHeader';
import Login from '../login/Login';
import { PlusIcon, SubIcon } from '../recipeList/RecipeData'
import DashboardBottom from './DashboardBottom'
import BuildNewPlan from '../plans/BuildNewPlan';
import history from '../../history';
import GroceryList from '../groceryList/GroceryList';
// import FeedbackPopup from '../UserFeedback/FeedbackPopup';
import NotesPopup from './NotesPopup';
import UpgradePlan from '../billingDetails/UpgradePlan'
import WeekRecipeData from './WeekRecipeData';
import MobileRecipeData from './MobileRecipeData';


class Dashboard extends Component {
  constructor(props) {
    super(props);
    const weekStartEnd = getSelectedWeekDates('currentWeek');
    const dayDates = getWeekDays(weekStartEnd);
    const dataProps = this.props.location.state !== undefined ? this.props.location.state : {}
    const planType = this.props.location.state ? this.props.location.state.exist : 'yes';
    const slideClass = window.innerWidth < 768 ? dataProps !== undefined && dataProps && dataProps.slideClass === undefined ? 'sliderighttrue' : dataProps.slideClass :''
    const isMobile = window.innerWidth < 768
    const useFor = this.props.location.useFor || 'actual'
    this.state = {
      dayDates,
      dashClass: 'active',
      reminder: false,
      inputs: {
        delete_meal_plan_schedule:[]
      },
      subscriptionPlan: [],
      planType,
      error: false,
      cookArr: [],
      recipeArr: [],
      cookingDate: [],
      servingArr: [],
      cookDayArr:[],
      lastStep: false,
      editRecipe: false,
      deleteRecipeIndex: [],
      bottomText: false,
      mbClass: 'mb-hide',
      showCook: false,
      calories:'0',
      recipeIdArr: [],
      groceryList: [],
      customItems: [],
      loader: true,
      showFeedbackPopup: false,
      redirectDash: false,
      slideRepeat: false,
      slideClass,
      showNotesPopup: false,
      notesError : false,
      popupType : 'create', 
      cardClass: 'vrt-chngs',
      activeCard: 'prep',
      cardSlideClass: 'slideleftfalse',
      showBillingPopup: false,
      isMobile,
      cookingDateRecipe: [],
      vRData: {},
      textMessage: false,
      showBuildPopup: false,
      cookDay:[],
      mealArr: [{type:'Breakfast', recipe: []}, {type:'Lunch', recipe: []}, {type:'Dinner', recipe: []}],
      notesArr:[],
      recipeIds: [],
      mealDay:[],
      groceryCategory:['Produce','Dairy & Eggs','Meat & Seafood', 'Canned & Packaged', 'Spices & Condiments'],
      groceryData: [], rcpIngredient: [],
      useFor,
      swapRecipe:dataProps.swapData || {},
      showSwapModal: false,
      showSwapRecipe: true
    };
    
  }

  componentDidMount() {
    // const { isMobile } = this.state
    localStorage.removeItem('hismain')
    sessionStorage.removeItem('planData')
    if(localStorage.getItem('rData') && browserName === 'Safari') {
      const backData = JSON.parse(localStorage.getItem('rData'))
      history.push('/library', {...backData, path:'dashboard' })
      localStorage.removeItem('rData')
    }
    window.onpopstate  = (e) => {
      if(e && localStorage.getItem('rData')) {
        const backData = JSON.parse(localStorage.getItem('rData'))
  
        if(e.state && e.state.state)
          backData.dayDates = e.state.state.dayDates
        history.push('/library', {...backData, path:'dashboard' })
        localStorage.removeItem('rData')
      }
    }
    
    // if(isMobile){
    document.body.style.overflow = "auto"

    const dataProps = this.props.location.state
    document.getElementsByTagName('body')[0].className = ''
    if(dataProps === undefined ||(dataProps && dataProps.bottomBtnState === undefined) || sessionStorage.getItem('method') !=='back'){
      let { dayDates } = this.state
      window.scrollTo(0,0)
      dayDates = this.props.location.state && this.props.location.state.dayDates !== undefined ? this.props.location.state.dayDates : dayDates
      if(sessionStorage.getItem('path')!=='dashboard' && sessionStorage.getItem('method') !=='back'){
        const weekStartEnd = getSelectedWeekDates('currentWeek');
        dayDates = getWeekDays(weekStartEnd);
      }
      if((localStorage.getItem('analytics') && localStorage.getItem('feedback') !=='submit' )
      || (sessionStorage.getItem('plan') === 'create' && sessionStorage.getItem('method') !=='back')) {
        const plan = sessionStorage.getItem('plan') === 'create' ? 'create' : 'survey'
        this.showFeedback(plan)
      }
      if (this.props.location.pathname === '/groceryList') {

        this.groceryPlan(dayDates)
      }
      if (this.props.location.pathname === '/dashboard' || this.props.location.pathname === '/firstplanweek') {
        if(this.props.location.pathname === '/firstplanweek')
          dayDates = this.props.location.state && this.props.location.state.dayDates !== undefined ? this.props.location.state.dayDates : dayDates
        this.fetchPlan(dayDates)
        sessionStorage.removeItem('method')
        const email = localStorage.getItem('email')
        window.analytics.track('Views Dashboard', {
          startDate: `${dayDates[0].fullDay} ${dayDates[0].date}-${dayDates[0].Month}-${dayDates[0].Year}`,
          id: email
        });
      }
    } else if(dataProps && sessionStorage.getItem('method') ==='back') {
      const slideClass = window.innerWidth < 768 ? 'dashslideleft' :''
      this.useHistoryData(dataProps, slideClass)
    }
    

    sessionStorage.removeItem('recipeArr')
    sessionStorage.removeItem('method')
    sessionStorage.removeItem('path')
    sessionStorage.removeItem('filter')
    sessionStorage.removeItem('viewAll')
    sessionStorage.removeItem('bottom')
    if (this.props.location.pathname === '/newUser') {
      this.sampleDashboard()
    }
  }

  


  onResize() {
    let { cardClass, cardSlideClass } = this.state
    const { activeCard  } = this.state
    window.scrollTo(0,0)
    if(window.innerWidth < 768) {
      cardClass = activeCard === 'prep' ? 'vrt-chngs' : ''
      if(activeCard === 'prep'){
        cardSlideClass = 'slideleftfalse'
      }
      this.setState({ cardClass, activeCard, cardSlideClass, isMobile: true })
    } else {
      cardClass = ''
      this.setState({ cardClass, activeCard, cardSlideClass, isMobile: false })
    }
  }


  getWeekData(dayDates, selectedWeek, previousWeek) {
    const { inputs, groceryClass, slideRepeat } = this.state
    let { previous } = this.state
    inputs.cooking_data = []
    inputs.meal_plan_data = []
    inputs.delete_meal_plan_schedule = []
    inputs.delete_cooking_recipe = []
    let slide;
    const vRData = {
      popupIndex:-1,
    }
    sessionStorage.setItem('height','desc')
    previous = previousWeek !== 'auto'
    if (selectedWeek === 'nextWeek') {
      slide= window.innerWidth < 768 ? `slideleft${slideRepeat}`: ''
    } else if (selectedWeek === 'previousWeek') {
      slide= window.innerWidth < 768 ? `slideright${slideRepeat}`: ''
    }
    this.setState({ 
      recipeArr: [], previous, cookingDate: [], inputs, loader: true, slideClass: slide, slideRepeat: !slideRepeat, 
      cookDay:[], mealArr: [{type:'Breakfast', recipe: []}, {type:'Lunch', recipe: []}, {type:'Dinner', recipe: []}],
      recipeIds: [], vRData
    })
    if(groceryClass !== 'active')
      this.fetchPlan(dayDates)
    else {
      this.groceryPlan(dayDates)
    }
  }
  setServingSize(index) {
    const { recipeArr, dayDates } = this.state
    const servingSize = parseInt(recipeArr[index].servingSize,0)
    const id = localStorage.getItem('email')
    window.analytics.track('Change Serving Sizes', {
      startDate: `${dayDates[0].fullDay} ${dayDates[0].date}-${dayDates[0].Month}-${dayDates[0].Year}`,
      endDate: `${dayDates[6].fullDay} ${dayDates[6].date}-${dayDates[6].Month}-${dayDates[6].Year}`,
      id
    });
    return(
      <ul className="set-serving">		
        <li>
          <a className="mb-hide red-circle" onClick={()=>this.removeServing(index, servingSize)}>
            <SubIcon />
          </a></li>
        <li> <h6> {servingSize} Servings </h6></li>
        <li><a className="mb-hide Green-circle" onClick={()=>this.addServing(index, servingSize)}>
        

          <PlusIcon />
        </a></li>
      </ul>
     
    )
  }

  

  useHistoryData(dataProps, slideClass) {
    const { swapRecipe } = this.state
    let { showSwapModal, showSwapRecipe, recipeIds } = this.state
    if(sessionStorage.getItem('swapData') || (swapRecipe && swapRecipe.toId)) {
      showSwapModal = true
      showSwapRecipe = swapRecipe.totalCount > 1
      sessionStorage.removeItem('swapData')
      recipeIds = swapRecipe.recipeIds 
      const idIndex = recipeIds.findIndex(x=>x.id === swapRecipe.fromId)
      if(idIndex > -1) {
        if(recipeIds[idIndex].count === 1) {
          recipeIds.splice(idIndex,1)
        } else {
          recipeIds[idIndex].count -=1
        }
      }
    } else if(dataProps.bottomBtnState) {
      recipeIds = dataProps.bottomBtnState.recipeIds
    }
    this.setState({ ...dataProps.bottomBtnState, slideClass, showSwapModal, swapRecipe, showSwapRecipe, recipeIds})
    if(showSwapRecipe) {
      setTimeout(()=>{
        this.setState({ showSwapRecipe: false})
        setTimeout(()=> {
          this.setState({ showSwapModal: false})
        },2000)
      },15000)
    } else {
      setTimeout(()=> {
        this.setState({ showSwapModal: false})
      },2000)
    }
    // setTimeout(()=>{this.setState({ showSwapModal: false})},15000)

    if(dataProps.bottomBtnState) {
      const activeClass = dataProps.bottomBtnState.activeCard
      if(activeClass !== 'prep') {
        document.getElementById('prep').className = ""
        document.getElementById('meal').className = "recipe-card-view-btn";
      }
      if(activeClass !== 'meal') {
        document.getElementById('meal').className = ""
        document.getElementById('prep').className = "recipe-card-view-btn";
      }
    }
  }

  groceryPlan(dayDates) {
    this.setState({ groceryClass: 'active', dashClass: '' });
    const inputs = {}
    const url = RoutingConstants.groceryList;
    const startDate = `${dayDates[0].Year}-${dayDates[0].Month}-${dayDates[0].date}`;
    const endDate = `${dayDates[6].Year}-${dayDates[6].Month}-${dayDates[6].date}`;
    inputs.week_start_date = startDate;
    inputs.week_end_date = endDate;
    post(url, inputs).then((response) => {
      this.setState({
        groceryList: response.result.groceries,
        customItems: response.result.custom,
        dayDates, 
        loader: false,
        error: false
      });
      if(response.result && response.result.trial_ends_at !== null) {
        this.showBillingPopup(response.result.trial_ends_at)
      }
    }).catch((err) => {
      this.setState({ groceryList: [], recipeList: [], dayDates, loader: false, error: true });
      if (err.error === 'token_expired') {
        localStorage.removeItem('token');
        history.push('/login');
      }
      if(err.result && err.result.trial_ends_at !== null) {
        this.showBillingPopup(err.result.trial_ends_at)
      }
    });
  }


  async editPlan(inputs,action) {
    const url = RoutingConstants.editNewPlan
    const { dayDates, defaultServingSize } = this.state
    inputs.groceryData = []
    inputs.groceryData = this.groceryData()
    
    await put(url,inputs).then(()=>{
      // inputs.response = response.data
      this.setState({ 
        deleteRecipeIndex: [] , editRecipe: false, textMessage:true,
        bottomText: false, mbClass: 'mb-only', servingArr:[], loader: false, inputs, groceryData:[], showSwapRecipe: false
      })
      if(action === 'swap') {
        this.fetchPlan(dayDates)
      }
      const id = localStorage.getItem('email')
      window.analytics.track('Plan Changes Saved', {
        startDate: `${dayDates[0].fullDay} ${dayDates[0].date}-${dayDates[0].Month}-${dayDates[0].Year}`,
        endDate: `${dayDates[6].fullDay} ${dayDates[6].date}-${dayDates[6].Month}-${dayDates[6].Year}`,
        id
      });
    }).catch((err)=>{
      err.result = {serving_size: defaultServingSize}
      this.catchError(err, dayDates)
    })
  }

  catchError(err, dayDates) {
    const { inputs } = this.state
    let defaultServingSize = 2
    if (err.error === 'token_expired') {
      localStorage.removeItem('token');
      history.push('/login', {location: this.state.location});
    }
    if(err.result && err.result.serving_size) {
      defaultServingSize = err.result.serving_size
    }
    if(err.result && err.result.vegan) {
      inputs.vegan = err.result.vegan
    }
    this.setState({error: true, dayDates, defaultServingSize, loader: false, textMessage: false, showBuildPopup: true, inputs })
  }

  async fetchPlan(dayDates) {
    const  { 
      servingArr, deleteRecipeIndex, cookDayArr, recipeArr, cookingDate, mealDay, useFor
    } = this.state
    const { cookArr } = this.state
    const url = RoutingConstants.getNewPlan;
    const { inputs } = this.state
    let { cookDay, recipeIds, mealArr } = this.state
    const startDate = `${dayDates[0].Year}-${dayDates[0].Month}-${dayDates[0].date}`;
    const endDate = `${dayDates[6].Year}-${dayDates[6].Month}-${dayDates[6].date}`;
    inputs.week_start_date = startDate;
    inputs.week_end_date = endDate;
    inputs.user_weekly_schedule_id = ''
    inputs.cooking_data = []
    inputs.meal_plan_data = []
    inputs.delete_meal_plan_schedule = []
    inputs.delete_cooking_recipe = []
    recipeIds = []
    mealArr = [{type:'Breakfast', recipe: []}, {type:'Lunch', recipe: []}, {type:'Dinner', recipe: []}]
    cookDay = []
    post(url, inputs).then(response =>{
      if(response.result && response.result.trials_end_at !== null) {
        this.showBillingPopup(response.result.trials_end_at)
      }
      if(response.result.user_weekly_schedule_id) {
        inputs.user_weekly_schedule_id = response.result.user_weekly_schedule_id
        inputs.vegan = response.result.vegan
        inputs.response = response.result
      }
      let recipes = 0
      response.result.recipeIdsArray.map(ids=>{
        if(recipes === 0) {
          recipes=ids
        } else {
          recipes += `,${ids}`
        }
        return null
      })

      response.result.recipeBundleIdsArray = _.uniq(response.result.recipeBundleIdsArray)
      let recipeBundle = null
      response.result.recipeBundleIdsArray.map(ids=>{
        if(recipeBundle === null) {
          recipeBundle=ids
        } else {
          recipeBundle += `,${ids}`
          // recipeIds.push({})
        }
        
        return null
      })
      let bundleItems = []
      const contBundleRecipe = `${RoutingConstants.bundleSelectedRecipe}${recipeBundle}`
      get(contBundleRecipe,'contentful').then(bundleResult=>{
        bundleItems = bundleResult.items
        bundleResult.items.map(bundleRcp=>{
          bundleRcp.fields.bundleRecipe.map(bunRcp=>{
            if(recipes === 0) {
              recipes=bunRcp.sys.id
            } else {
              recipes += `,${bunRcp.sys.id}`
            }
            return bunRcp
          })
          return bundleRcp
        })
        const contRecipe = `${RoutingConstants.contentfulRecipe}${recipes}`
        get(contRecipe,'contentful').then(result=>{
          result.items = result.items.concat(bundleItems)
          
          if(result.items){
        
            inputs.response.cooking_schedule.map(item=>{
              const dDate = moment(item.cooking_date).format('DD')
              const day = dayDates.findIndex(x=>x.date === dDate)
              const cookInd = cookDay.findIndex(x=>x.cooking_date === item.cooking_date)
              if(cookInd === -1){
            
                cookDay.push({ cooking_date: item.cooking_date, recipe: [], totalHands: 0, totalTime: 0, cooking_day: dayDates[day].day })
                const len = cookDay.length - 1
                item.recipe.map(rcp=>{
                  const resIndex = result.items.findIndex(x=>x.sys.id === rcp.recipe_id)
                  if(!validateInputs('number',rcp.recipe_id)){
                    const type = rcp.isBundle === 0 ? 'meal' : 'bundle'
                    const idIndex = recipeIds.findIndex(x=>x.id === rcp.recipe_id && x.type === type)
                    if(idIndex > -1) {
                      recipeIds[idIndex].count += 1
                    } else {
                      recipeIds.push({ id: rcp.recipe_id, count : 1, size : 0, type})
                    }}
                  if(resIndex > -1){
                    const bundleRecipe = []
                    if(rcp.isBundle === 1) {
                      result.items[resIndex].fields.bundleRecipe.map(bundleRcp=>{
                        const resBundleIndex = result.items.findIndex(x=>x.sys.id === bundleRcp.sys.id)
                        if(resBundleIndex > -1) {
                          
                          result = this.recipeDataAdd(result, resBundleIndex, rcp, 0,'yes')

                          bundleRecipe.push({
                            name:result.items[resBundleIndex].fields.name, 
                            id: result.items[resBundleIndex].sys.id,
                            recipe: result.items[resBundleIndex].fields,
                            activeTime: result.items[resBundleIndex].fields.activeRcpTime,
                            totalTime: result.items[resBundleIndex].fields.totalRcpTime ,
                            equipmentIcon: result.items[resBundleIndex].fields.equipmentRcpIcon,
                            servingSize: rcp.recipe_serving_size,
                            side_dish_id: result.items[resBundleIndex].fields.sideId,
                            sideRecipe: result.items[resIndex].fields.sideRecipe,
                          }) 
                        }
                        return null
                      })  
                    }
                    result = this.recipeDataAdd(result, resIndex, rcp, rcp.isBundle, 'no')
                   
              
                    cookDay[len].totalHands += result.items[resIndex].fields.activeRcpTime 
                    cookDay[len].totalTime = compareRecipeTime(result.items[resIndex].fields.totalRcpTime, cookDay[len].totalTime)
    
                    result.items[resIndex].fields.activeRcpTime = getTimeStamp(result.items[resIndex].fields.activeRcpTime) 
                    result.items[resIndex].fields.totalRcpTime = getTimeStamp(result.items[resIndex].fields.totalRcpTime)
                    const name = rcp.isBundle === 0 ? result.items[resIndex].fields.name : result.items[resIndex].fields.bundleTitle
                    cookDay[len].recipe.push({
                      name,
                      recipe_id: rcp.recipe_id,
                      activeTime: result.items[resIndex].fields.activeRcpTime,
                      totalTime: result.items[resIndex].fields.totalRcpTime ,
                      equipmentIcon: result.items[resIndex].fields.equipmentRcpIcon,
                      recipe: result.items[resIndex].fields,
                      servingSize: rcp.recipe_serving_size,
                      side_dish_id: rcp.side_dish_id,
                      sideRecipe: result.items[resIndex].fields.sideRecipe,
                      id: rcp.id,
                      isBundle:rcp.isBundle,
                      bundleRecipe
                      // recipeImg
                    })
                    cookDay[len].cooking_id = rcp.user_cooking_date_id  
                  }
                
                  return null;      
                })   
                cookDay[len].totalTime = compareRecipeTime(cookDay[len].totalHands, cookDay[len].totalTime)
                cookDay[len].totalHands = getTimeStamp(cookDay[len].totalHands)
                cookDay[len].totalTime = getTimeStamp(cookDay[len].totalTime)}
              return null;
            })
            cookDay = cookDay.sort(sortByKey('cooking_date','asc'))
            inputs.response.meal_plan.map(item => {
              const dDate = moment(item.cooking_date).format('DD')
              const day = dayDates.findIndex(x=>x.date === dDate)
              mealDay.push({ cooking_date: item.cooking_date, recipe: [], cooking_day: dayDates[day].day })
              const len = mealDay.length - 1
              
              item.recipe.map(rcp=>{
                const resIndex = result.items.findIndex(x=>x.sys.id === rcp.recipe_id)
                if(resIndex > -1){
                  let cookIndex = -1
                  let cookCount = 0
                  let cookDayIndex = null
                  
                  cookDay.map((cookdate,index)=>{
                    // const rId = cookdate.isBundle === 1 ? bundleItems.recipeId: item.recipe_id
                    // const bunIndex = cookdate.recipe.findIndex(x=>x.isBundle === rcp.isBundle)
                    // if(rcp.isBundle === )
                    let rcpIndex = cookdate.recipe.findIndex(x=>x.recipe_id === rcp.recipe_id )
                    const bunIndex = cookdate.recipe.findIndex(x=>x.isBundle === 1)
                    if(rcpIndex === -1) {
                      if(bunIndex > -1 && rcp.isBundle === 1) {
                        rcpIndex = cookdate.recipe[bunIndex].bundleRecipe.findIndex(x=>x.id === rcp.recipe_id)
                        if(rcpIndex > -1 && cookCount === 0 ) {
                          cookCount += 1;
                          cookDayIndex = cookdate.cooking_day
                          cookIndex = index
                        }
                      }
                    }
                    else if(rcpIndex > -1 && cookCount === 0 && rcp.isBundle === 0 ) {
                      cookCount += 1;
                      cookDayIndex = cookdate.cooking_day
                      cookIndex = index
                    }
                    return null;
                  })
                  let results = -1
              
                  if(cookDay[cookIndex]){
                    const startCompareDate = moment(cookDay[cookIndex].cooking_date)
                    const endCompareDate = moment(item.cooking_date)
                    results = endCompareDate.diff(startCompareDate,'days')
                  }
      
                  const mIndex = rcp.meal_plan_type === 'Breakfast' ? 0 :  rcp.meal_plan_type === 'Lunch' ? 1 : 2
                
                
                  let image = '/images/small.png'
                  if(result.items[resIndex].fields.image){
                    const imageIndex = result.includes.Asset.findIndex(x=>x.sys.id === result.items[resIndex].fields.image.sys.id)
                    if(imageIndex > -1) {
                      image = `https:${result.includes.Asset[imageIndex].fields.file.url}`
                    }
                  }
                  result.items[resIndex].fields.recipeImage = image
                  // result.items[resIndex].fields.sideRecipe = {}
                  if(result.items[resIndex].fields.recipeSides && result.items[resIndex].fields.recipeSides.length > 0 ) {
                    const sideIndex = result.items.findIndex(x=>x.sys.id === result.items[resIndex].fields.recipeSides[0].sys.id )
                    if(sideIndex > -1) {
                      result.items[resIndex].fields.sideRecipe = result.items[sideIndex].fields
                      result.items[resIndex].fields.sideRecipe.sideId = result.items[sideIndex].sys.id
                      if( result.items[sideIndex].fields &&  result.items[sideIndex].fields.image){
                        const sideimageIndex = result.includes.Asset.findIndex(x=>x.sys.id === result.items[sideIndex].fields.image.sys.id)
                        if(sideimageIndex > -1) {
                          result.items[resIndex].fields.sideRecipe.recipeImage = `https:${result.includes.Asset[sideimageIndex].fields.file.url}`
                        }
                      }

                      result.items[resIndex].fields.sideRecipe.recipeIngredient = []
                      result.items[resIndex].fields.recipeIngredient = this.recipeIngredient(
                        result.items[resIndex].fields.sideRecipe.ingredientsData, result.items[resIndex].fields.sideRecipe.recipeIngredient, result
                      )
         
                      result.items[resIndex].fields.sideRecipe.recipeInstruction = []
                      result.items[resIndex].fields.sideRecipe.recipeInstruction = this.recipeInstruction(
                        result.items[resIndex].fields.sideRecipe.instructions, result.items[resIndex].fields.sideRecipe.recipeInstruction, result)

                  
                    }
                  }
                  const sideName = result.items[resIndex].fields.sideRecipe ? result.items[resIndex].fields.sideRecipe.name : null
                  const dIndex = mealArr[mIndex].recipe.findIndex(x=>x.meal_date === item.cooking_date && 
                  x.recipe_id === rcp.recipe_id && 
                  mealArr[mIndex].type === rcp.meal_plan_type)

                  result.items[resIndex].fields.recipeInstruction = []
                  result.items[resIndex].fields.recipeInstruction = this.recipeInstruction(
                    result.items[resIndex].fields.instructions, result.items[resIndex].fields.recipeInstruction, result)
              

                  result.items[resIndex].fields.recipeIngredient = []
                  result.items[resIndex].fields.recipeIngredient = this.recipeIngredient(
                    result.items[resIndex].fields.ingredientsData, result.items[resIndex].fields.recipeIngredient, result
                  )
                
                  let activeTime = result.items[resIndex].fields.handsOnTime
                  let totalTime = result.items[resIndex].fields.handsOnTime + result.items[resIndex].fields.passiveTime
                  let sideTotal = 0
                  // alert(activeTime)
                  if(result.items[resIndex].fields.sideRecipe) {
                    activeTime += result.items[resIndex].fields.sideRecipe.handsOnTime
                    sideTotal = result.items[resIndex].fields.sideRecipe.handsOnTime + result.items[resIndex].fields.sideRecipe.passiveTime
                  }
              
                  totalTime = compareRecipeTime(totalTime, sideTotal)
                  totalTime = compareRecipeTime(totalTime, activeTime)
                  activeTime = getTimeStamp(activeTime)
                  totalTime = getTimeStamp(totalTime)
                
                  result.items[resIndex].fields.equipmentIcon = `/images/none.svg`
                  if(result.items[resIndex].fields.equipmentTypes){
                    const equipIndex = result.includes.Entry.findIndex(x=>x.sys.id=== result.items[resIndex].fields.equipmentTypes[0].sys.id)
                    if(equipIndex > -1) {
        
                      result.items[resIndex].fields.equipmentIcon = `/images/${result.includes.Entry[equipIndex].fields.icon}`
                      // result.items[resIndex].fields.equipmentName = result.includes.Entry[equipIndex].fields.title
                    } 
                  }

                  const mealIndex = mIndex === 0 ? 'A' : mIndex === 1 ? 'B' : 'C'
                
                  if(item.cooking_date === rcp.meal_plan_date)
                    mealDay[len].recipe.push({
                      name: result.items[resIndex].fields.name,
                      recipe_id: rcp.recipe_id,
                      activeTime,
                      totalTime ,
                      equipmentIcon: result.items[resIndex].fields.equipmentIcon,
                      recipe: result.items[resIndex].fields,
                      servingSize: rcp.recipe_serving_size,
                      side_dish_id: rcp.side_dish_id,
                      sideRecipe: result.items[resIndex].fields.sideRecipe,
                      id: rcp.id,
                      type: rcp.meal_plan_type,
                      index: mealIndex,
                      isBundle: rcp.isBundle,
                      sideName: result.items[resIndex].fields.sideRecipe ? result.items[resIndex].fields.sideRecipe.name : null
                    })
    
                  if(dIndex === -1 && item.cooking_date === rcp.meal_plan_date){
                    const type = rcp.isBundle === 1 ? 'mealbundle' : 'meal'
                    if(!validateInputs('number',rcp.recipe_id)){
                      
                      const idIndex = recipeIds.findIndex(x=>x.id === rcp.recipe_id && x.type === type)
                      if(idIndex > -1) {
                        recipeIds[idIndex].size += rcp.recipe_serving_size
                        recipeIds[idIndex].count += 1
                      } else {
                        recipeIds.push({ id: rcp.recipe_id, size : rcp.recipe_serving_size, count: 0, type})
                      }
                    }
                    // console.log(recipeIds)
                    mealArr[mIndex].recipe.push({ 
                      recipe_id: result.items[resIndex].sys.id,
                      id: rcp.id,
                      name: result.items[resIndex].fields.name,
                      meal_date: item.cooking_date,
                      sideName,
                      image,
                      cookDay: results >=0 ?  cookDayIndex: null,
                      cookIndex: results >=0 ? cookIndex : null,
                      recipe: result.items[resIndex].fields,
                      servingSize: rcp.recipe_serving_size,
                      isBundle: rcp.isBundle,
                      recipeData: {
                        items:{ recipe: result.items[resIndex].fields},
                        recipe_sides:result.items[resIndex].fields.sideRecipe ? result.items[resIndex].fields.sideRecipe : null,
                        totalHands: activeTime,
                        totalTime,
                        servingSize: rcp.recipe_serving_size,
                        isBundle: rcp.isBundle
                      }
                    })}
                }
             
                return null;
              })
              return  null;
            })
          }
          const notesArr = response.result.notes ? response.result.notes : []
          this.setState({ 
            cookArr, recipeArr, cookingDate, lastStep: true, servingArr,
            deleteRecipeIndex, cookDayArr, inputs, dayDates, error: false, notesArr,
            recipeIdArr:[], defaultServingSize: response.result.serving_size, loader: false, mealArr, cookDay, recipeIds
          })
        })
        if(useFor === 'newUser') {
          this.props.sampleDash()
        }
      // let rcpCount = 0
        
      }).catch((err)=>{
        if(useFor === 'newUser') {
          this.props.sampleDash()
        }
        this.catchError(err, dayDates)
      })
    }).catch(err=>{
      if(err.result && err.result.trials_ends_at !== null) {
        this.showBillingPopup(err.result.trials_end_at)
      }
      // inputs.vegan = err.result.vegan
      this.catchError(err, dayDates)
    })  
  }

  addServing(index, servingSize, vRData) {
    const { recipeArr, mealArr, recipeIds } = this.state
    // let { inputs } = this.state
    if(servingSize < 100) {
      const rindex = index.split('type')
      mealArr[rindex[0]].recipe[rindex[1]].recipeData.servingSize += 1
      mealArr[rindex[0]].recipe[rindex[1]].servingSize += 1
      const recIndex = recipeIds.findIndex(x=>x.id ===mealArr[rindex[0]].recipe[rindex[1]].recipe_id)
      if(recIndex > -1 ) {
        recipeIds[recIndex].size += 1
      }
    }
    this.setState({ recipeArr, bottomText: true, mbClass:'', vRData, textMessage: false, mealArr, recipeIds })
  }
  

  removeServing(index, servingSize, vRData) {
    const { mealArr, recipeIds } = this.state
    // let { inputs } = this.state
    if(servingSize > 1) {
      const rindex = index.split('type')
      mealArr[rindex[0]].recipe[rindex[1]].recipeData.servingSize -= 1
      mealArr[rindex[0]].recipe[rindex[1]].servingSize -= 1
      const recIndex = recipeIds.findIndex(x=>x.id ===mealArr[rindex[0]].recipe[rindex[1]].recipe_id)
      if(recIndex > -1 ) {
        recipeIds[recIndex].size -= 1
      }
      
    }
    this.setState({ mealArr, bottomText:true, mbClass:'', vRData, textMessage: false, recipeIds })
  }

  recipeTime(days) {
    const { recipeArr, recipeIdArr } = this.state
    let totalCookTime = 0
    let totalCookHands = 0
    
    recipeArr.map((item) => {
      if(item.cooking_date === days.cooking_date ){
        totalCookTime +=  formatTimeStamp(item.totalTime) 
        totalCookHands +=  formatTimeStamp(item.totalHands )
        if(recipeArr.length > recipeIdArr.length)
          recipeIdArr.push(item.items.recipe.recipe_id)
      }
      return totalCookTime
    })
    
    totalCookTime = getTimeStamp(totalCookTime)
    totalCookHands = getTimeStamp(totalCookHands)
   
    return `${totalCookTime},${totalCookHands}, ${recipeIdArr}`
  }


  editServing(index) {
    const { servingArr, recipeArr } = this.state
    const servingIndex = servingArr.findIndex(x=>x.index === index)
    if(servingIndex === -1) {
      servingArr.push({ index, servingSize: recipeArr[index].servingSize})
    }
    this.setState({ servingArr })
  }

  deleteRecipe(index, id) {
    const { mealArr, deleteRecipeIndex, servingArr, inputs, recipeIds } = this.state
    
    const rindex = index.split('type')
    const type = mealArr[rindex[0]].recipe[rindex[1]].isBundle === 0 ? 'meal' : 'mealbundle'
    const recIndex = recipeIds.findIndex(x=>x.id === mealArr[rindex[0]].recipe[rindex[1]].recipe_id && x.type === type )
    // alert(recIndex)
    if(recIndex > -1 ){
      recipeIds[recIndex].size -=  mealArr[rindex[0]].recipe[rindex[1]].servingSize
      if(recipeIds[recIndex].size === 0) {
        recipeIds.splice(recIndex,1)
      } 
    }
    mealArr[rindex[0]].recipe.splice(rindex[1],1)
    
    inputs.delete_meal_plan_schedule.push(id)
    this.setState({ loader: true})
    const vRData = {
      popupIndex: -1
    }
    const url = RoutingConstants.editNewPlan
    inputs.groceryData = this.groceryData()
    put(url,inputs).then(()=>{
      this.setState({ loader: false, inputs, groceryData:[] })
    }).catch(()=>{
      this.setState({ loader: false})
    })
    this.setState({ deleteRecipeIndex, servingArr, bottomText: true, mbClass: '', recipeIds, vRData })
  }
  
  groceryData() {
    const { mealArr, groceryData } = this.state
    
    mealArr.map(item => {
      item.recipe.map(rcp => {
        
        if (rcp.recipe) {
        
          rcp.recipe.recipeIngredient.map(value => {
            let quantity = value.quantity;
            quantity *= (rcp.servingSize / 4);
            const gIndex = groceryData.findIndex(x => x.grocery_category_id === (value.ingredient.groceryId + 1) && x.ingredient_name === value.ingredient.name
              && x.measument_unit === value.unit);
            if (gIndex > -1) {
              groceryData[gIndex].ingredient_quantity += quantity;
            }
            else {
              groceryData.push({
                grocery_category_id: value.ingredient.groceryId + 1,
                ingredient_name: value.ingredient.name,
                ingredient_quantity: quantity,
                measument_unit: value.unit ? value.unit : null
              });
            }
            return null;
          });
        }
        if (rcp.sideRecipe) {
          rcp.sideRecipe.recipeIngredient.map(value => {
            let quantity = value.quantity;
            quantity *= (rcp.servingSize / 4);
            const gIndex = groceryData.findIndex(x => x.grocery_category_id === (value.ingredient.groceryId + 1) && x.ingredient_name === value.ingredient.name
              && x.measument_unit === value.unit);
            if (gIndex > -1) {
              groceryData[gIndex].ingredient_quantity += quantity;
            }
            else {
              groceryData.push({
                grocery_category_id: value.ingredient.groceryId + 1,
                ingredient_name: value.ingredient.name,
                ingredient_quantity: quantity,
                measument_unit: value.unit ? value.unit : null
              });
            }
            return null;
          });
        }
        return null;
      });
      return null;
    })
   
    return groceryData
  }
  
  createPlan(weekDate, from) {
    const { defaultServingSize, dayDates, inputs, cookDay, mealArr, recipeIds } = this.state
    const cDate = []
    sessionStorage.setItem('plan','create');
    // history.push('/selectMeals',{dayDates: weekDate, servingSize: defaultServingSize})
    // loop for adding cooking
    dayDates.map(item=>{  
      const itemDate = `${item.Year}-${item.Month}-${item.date}`;
      cDate.push({cooking_date:itemDate})
      return cDate
    })
    history.push('/library',{dayDates: weekDate, servingSize: defaultServingSize, recipeIds,
      cookingDates: cDate, inputs, from, cookDay, mealArr})

  }

  viewRecipe(totalHandsOn, totalTime, totalPassive, rname, sname, recipe, totalServing) {
    const { editRecipe, defaultServingSize, dayDates } = this.state
    if(!editRecipe) {
      window.scroll(0,0)
      localStorage.removeItem('rData')
      history.push('/viewRecipe',{ 
        path:'dashboard', totalHandsOn, totalTime, totalPassive, rname, sname, 
        recipe, dayDates, totalServing,defaultServingSize, state:this.state
      })
    }
  }

  showFeedback(value) {
    this.setState({ showFeedbackPopup: true, popupType:value})
  }

  submitFeedback(inputs) {
    this.setState({ loader: true })
    const url = RoutingConstants.userFeedback
    localStorage.setItem('feedback','submit')
    post(url, inputs).then(()=>{
      this.setState({ loader: false})
    }).catch(()=>{
      this.setState({ loader: false})
    })
  }

  updateFeedback(inputs) {
    this.setState({ loader: true })
    const url = RoutingConstants.userFeedback
    put(url, inputs).then(()=>{
      localStorage.setItem('feedback','submit')
      this.setState({ loader: false})
    }).catch(()=>{
      this.setState({ loader: false})
    })
  }

  removeFeedbackPopup() {
    this.setState({ showFeedbackPopup: false})
    localStorage.removeItem('analytics')
    sessionStorage.removeItem('plan')
  }
  
  closeWelcomePopup() {
    setTimeout(()=>{this.setState({ showFeedbackPopup: false})},1000)
    sessionStorage.removeItem('plan')
  }
	
  // show notes toggling function
  showNotes(notesDate, notesMode, notes, cookIndex) {
    
    const { showNotesPopup} = this.state
    // if(!previous)
    this.setState({ showNotesPopup: !showNotesPopup, notesDate, notesMode, notes, cookIndex, notesError: false })
  }

  notesSave(inputs, notesDate, mode) {
    const { notesArr, dayDates }  = this.state
    let { showNotesPopup, notesError}  = this.state
    this.setState({ loader: true})
    
    const url = mode=== 'add' ? RoutingConstants.addNotes : RoutingConstants.editNotes
    const  reqParams = mode=== 'add' ? post(url,inputs) : put(url,inputs)
    let notesMode = mode
    
    reqParams.then(response=>{
      if(mode === 'add') {
        notesArr.push({ content: inputs.content, date:inputs.date, id: response.result.id})
        const id = localStorage.getItem('email')
        window.analytics.track('Notes saved', {
          startDate: `${dayDates[0].fullDay} ${dayDates[0].date}-${dayDates[0].Month}-${dayDates[0].Year}`,
          endDate: `${dayDates[6].fullDay} ${dayDates[6].date}-${dayDates[6].Month}-${dayDates[6].Year}`,
          noteDate: notesDate,
          noteContent: inputs.content,
          id
        });
      } else {
        const nindex = notesArr.findIndex(x=>x.date === notesDate)
        if(nindex > -1) {
          notesArr[nindex].content = inputs.content
        }
      }
      if(response.result) {
        showNotesPopup = false
        notesError = false
        notesMode = 'edit'
      } else {
        showNotesPopup = true
        notesError = true
        notesMode = 'add'
      }
      this.setState({ loader: false,showNotesPopup, notesMode, notesError, notesArr })
    }).catch(()=>{
      this.setState({ loader: false })
    })
  }

  notesDelete(id) {
    const { showNotesPopup, notesArr }  = this.state
    this.setState({ loader: true})
    
    const url = `${RoutingConstants.deleteNotes}/${id}`
    const input =  {}
    input.id = id
    delet(url, input).then(()=>{
      const index = notesArr.findIndex(x=>x.id === id) 
      if(index >-1) {
        notesArr.splice(index,1)
      }
      // cookingDate[index].notes = null
      this.setState({ loader: false, showNotesPopup: !showNotesPopup, notesMode: 'add', notesArr  })
    }).catch(()=>{
      this.setState({ loader: false })
    })
  }

  closePopup() {
    this.setState({ showNotesPopup: false})
  }

  // card layout changes function
  showCardList(event, cardClass) {
    let { slideClass } = this.state
    const { dayDates } = this.state
    if(event.target.id !== 'prep') {
      document.getElementById('prep').className = ""
      event.target.className = "recipe-card-view-btn";
      slideClass = 'sliderighttrue'
    }
    if(event.target.id !== 'meal') {
      document.getElementById('meal').className = ""
      event.target.className = "recipe-card-view-btn";
      slideClass = 'slideleftfalse'
    }
    const id = localStorage.getItem('email')
    window.analytics.track('Dashboard Recipe Card View', {
      startDate: `${dayDates[0].fullDay} ${dayDates[0].date}-${dayDates[0].Month}-${dayDates[0].Year}`,
      endDate: `${dayDates[6].fullDay} ${dayDates[6].date}-${dayDates[6].Month}-${dayDates[6].Year}`,
      cardView: event.target.id,
      id
    });
    this.setState({ cardClass, activeCard: event.target.id, cardSlideClass: slideClass })
  }

  // billing popup
  showBillingPopup(trialDate) {
    const startDate = moment()
    const endDate = moment(trialDate)
    const result = endDate.diff(startDate,'days')
    if(result < 0){
      this.setState({ showBillingPopup: true})
    }
  }

  closeBillingPopup() {
    this.setState({ showBillingPopup: false })
  }

  viewDesktopRecipe(recipe, rname, sname, totalServing, vRData) {
    const { dayDates, defaultServingSize } = this.state
    let totalPassive = differnceTimeStamp(recipe.totalTime, recipe.totalHands.split('m')[0])
    totalPassive = getTimeStamp(totalPassive)
    const data = vRData ? recipe.items.recipe : recipe.recipe
    this.setState({ vRData })
    history.push('/viewRecipe',{ 
      path:'dashboard', totalHandsOn: recipe.totalHands, totalTime: recipe.totalTime, totalPassive, rname, sname, 
      recipe:data, dayDates, totalServing, defaultServingSize, state:this.state, vRData, sideRecipe: recipe.recipe_sides
    })
  }

  closeRecipePopup(vRData) { 
    this.setState({ vRData })
    document.body.style.overflow = ""
  }

  editServingSize(params, vRData) {
    const { inputs } = this.state
    params.week_start_date = inputs.week_start_date;
    params.week_end_date = inputs.week_end_date;
    params.user_weekly_schedule_id = inputs.user_weekly_schedule_id;
    
    this.setState({ vRData })
    // const { cookingDate } = this.state
    this.editPlan(params, 'serving')
  }

  closeBuildPopup() {
    this.setState({ showBuildPopup: false})
  }

  // eslint-disable-next-line
  recipeInstruction(data,recipeInsData, result) {
    // return(
    data.map(inst=>{
      const insIndex = result.includes.Entry.findIndex(x=>x.sys.id=== inst.sys.id)
      if(insIndex > -1) {
        recipeInsData.push({instruction: result.includes.Entry[insIndex].fields.instructionText, id: inst.sys.id})
      }
      return null;
    })
    // )
    return recipeInsData
  }

  recipeIngredient(data,recipeIndData, result) {
    const { groceryCategory } = this.state
    data.map(ingd=>{
      const ingIndex = result.includes.Entry.findIndex(x=>x.sys.id === ingd.sys.id)
      if((ingIndex > -1) ) {

        const ingNameIndex = result.includes.Entry.findIndex(x=>x.sys.id === result.includes.Entry[ingIndex].fields.ingredient.sys.id)
        if(ingNameIndex > -1){
          let unit = result.includes.Entry[ingIndex].fields.unit
          unit = unit === 'empty' ? null : unit
          const groceryId = groceryCategory.findIndex(x=>x===result.includes.Entry[ingNameIndex].fields.groceryCategory)
  
          recipeIndData.push({ 
            quantity: result.includes.Entry[ingIndex].fields.quantity, 
            id: ingd.sys.id, 
            unit,
            ingredient:{
              name:result.includes.Entry[ingNameIndex].fields.name,
              groceryId
            }
          })
        }
      }
      return ingd;
    })
    return recipeIndData
  }

  resetPlan() {
    const { inputs, dayDates } = this.state
    this.setState({ loader: true })
    const url = RoutingConstants.deleteNewPlan
    delet(url, inputs).then(()=>{
      this.setState({ cookDay:[], notesArr: [],
        mealArr: [{type:'Breakfast', recipe: []}, {type:'Lunch', recipe: []}, {type:'Dinner', recipe: []}],  })
      this.fetchPlan(dayDates)
    }).catch(()=>{
      this.setState({ loader: false })
    })
  }

  recipeDataAdd(result, index, rcp, isBundle, convertTime) {
    result.items[index].fields.recipeInstruction = []
    if(result.items[index].fields.instructions)
      result.items[index].fields.recipeInstruction = this.recipeInstruction(
        result.items[index].fields.instructions, result.items[index].fields.recipeInstruction, result)
                          
    result.items[index].fields.recipeIngredient = []
    if(result.items[index].fields.ingredientsData)
      result.items[index].fields.recipeIngredient = this.recipeIngredient(
        result.items[index].fields.ingredientsData, result.items[index].fields.recipeIngredient, result
      ) 

    let equipmentIcon = `/images/none.svg`
    if(result.items[index].fields.equipmentTypes){
      const equipIndex = result.includes.Entry.findIndex(x=>x.sys.id=== result.items[index].fields.equipmentTypes[0].sys.id)
      if(equipIndex > -1) {
          
        equipmentIcon = `/images/${result.includes.Entry[equipIndex].fields.icon}`
        // result.items[index].fields.equipmentName = result.includes.Entry[equipIndex].fields.title
      } 
    }
    result.items[index].fields.equipmentRcpIcon = equipmentIcon
    

    
    let activeTime = isBundle === 0 ? result.items[index].fields.handsOnTime : result.items[index].fields.bundleHandsOnTime
    const passiveTime = isBundle === 0 ? result.items[index].fields.passiveTime : result.items[index].fields.bundlePassiveTime
    let totalTime = activeTime + passiveTime
    let sideTotal = 0
    let sideId = null 
    if(result.items[index].fields.image){
      const imageIndex = result.includes.Asset.findIndex(x=>x.sys.id === result.items[index].fields.image.sys.id)
      if(imageIndex > -1) {
        result.items[index].fields.recipeImage = `https:${result.includes.Asset[imageIndex].fields.file.url}`
      }}
    if(result.items[index].fields.recipeSides && result.items[index].fields.recipeSides.length > 0 ) {
      const sideIndex = result.items.findIndex(x=>x.sys.id === result.items[index].fields.recipeSides[0].sys.id )
      if(sideIndex > -1) {
        result.items[index].fields.sideRecipe = result.items[sideIndex].fields
        result.items[index].fields.sideRecipe.sideId = result.items[sideIndex].sys.id
        sideId = result.items[sideIndex].sys.id
        if( result.items[sideIndex].fields &&  result.items[sideIndex].fields.image){
          const sideimageIndex = result.includes.Asset.findIndex(x=>x.sys.id === result.items[sideIndex].fields.image.sys.id)
          if(sideimageIndex > -1) {
            result.items[index].fields.sideRecipe.recipeImage = `https:${result.includes.Asset[sideimageIndex].fields.file.url}`
          }
        }
      
        result.items[index].fields.sideRecipe.recipeIngredient = []
        result.items[index].fields.sideRecipe.recipeIngredient = this.recipeIngredient(
          result.items[index].fields.sideRecipe.ingredientsData, result.items[index].fields.sideRecipe.recipeIngredient, result
        )
      }
    }
    if(result.items[index].fields.sideRecipe) {
      activeTime += result.items[index].fields.sideRecipe.handsOnTime
      sideTotal = result.items[index].fields.sideRecipe.handsOnTime + result.items[index].fields.sideRecipe.passiveTime
    }
    totalTime = compareRecipeTime(totalTime, sideTotal)
    totalTime = compareRecipeTime(totalTime, activeTime)
    let image = '/images/small.png'
    if(result.items[index].fields.image){
      const imageIndex = result.includes.Asset.findIndex(x=>x.sys.id === result.items[index].fields.image.sys.id)
      if(imageIndex > -1) {
        image = `https:${result.includes.Asset[imageIndex].fields.file.url}`
      }
    }
    result.items[index].fields.recipeImage = image
    if(convertTime === 'yes'){
      activeTime = getTimeStamp(activeTime) 
      totalTime = getTimeStamp(totalTime) 
    }
    result.items[index].fields.totalRcpTime = totalTime
    result.items[index].fields.activeRcpTime = activeTime
    result.items[index].fields.sideId = sideId
    return result
  }

  sampleDashboard() {
    this.setState({ loader: false})
  }


  swapRecipe(vRData) {
    const {
      recipeArr, dayDates, inputs,defaultServingSize, cookDay, mealArr, recipeIds
    } = this.state
    // const editWeek = []
    // const cookDate = recipeArr[index].cooking_date
    // editWeek.push({servingArr, deleteRecipeIndex, cookDayArr })
    // const swapRecipeName = recipeArr[index].items.recipe.name
    this.setState({ vRData })
    window.analytics.track(' Swap Recipe', {
      startDate: `${dayDates[0].fullDay} ${dayDates[0].date}-${dayDates[0].Month}-${dayDates[0].Year}`,
      endDate: `${dayDates[6].fullDay} ${dayDates[6].date}-${dayDates[6].Month}-${dayDates[6].Year}`,
      // swapRecipeName
    });
    localStorage.setItem('editRecipes',JSON.stringify(recipeArr));
    document.body.style.overflow = "auto"
    
    const recipeIndex = vRData.popupIndex.split('type')
    history.push('/library',{dayDates, servingSize: defaultServingSize, recipeIds, state: this.state, vRData,
      inputs, from:'dashboard', cookDay, mealArr, action:'swap', selectedRecipe: mealArr[recipeIndex[0]].recipe[recipeIndex[1]]})
  }

  // swap modal code
  swapModal() {
    const { swapRecipe, showSwapRecipe } = this.state
    console.log(swapRecipe)
    const swapClass = showSwapRecipe ? "edit-popup swap-popup" : "edit-popup swap-popup success" 
    return (
      <div className={swapClass}>
        <div className="modal fade in">
          <div className="modal-content">
            <h2> 
              Swap {showSwapRecipe ? 'for all?' : 'Successful!'}
              <img src="/images/clos.svg" alt="" className="cross" onClick={()=>this.hideSwapModal()}/>
            </h2>
            {showSwapRecipe ? 
              <div className="edit-content">
                <p> 
                Would you like to swap in 
                  <b> {swapRecipe.toRecipe} </b> 
                for every instance of
                  <b> {swapRecipe.fromRecipe} ?</b>
                </p>
              
                <div className="edit-text">
                  <div className="nw-rcp">
                    <button onClick={()=>this.swapEveryRecipe()}>Yes</button>
                  </div>
                  <div className="canc-swap">
                    <button className="cancl" onClick={()=>this.hideSwapModal()}> No </button>
                  </div>
                </div>
              
              </div>
              :
              <div className="edit-content">
                <p>
                Your changes have been saved
                </p>
              </div>  
            }
          </div>
        </div>
      </div>
  
    )
  }

  // eslint-disable-next-line
  swapEveryRecipe() {
    const params = {}
    const { mealArr, cookDay, swapRecipe, inputs, recipeIds } = this.state
    params.week_start_date = inputs.week_start_date
    params.week_end_date = inputs.week_end_date
    params.user_weekly_schedule_id = inputs.user_weekly_schedule_id
    params.cooking_data = []
    params.delete_user_cooking_dates = []
    params.meal_plan_data = []
    params.delete_meal_plan_schedule = []
    params.delete_cooking_recipe = []
    cookDay.map((item,index)=>{
      const cookIndex = item.recipe.findIndex(x=>x.recipe_id === swapRecipe.fromId)
      if(cookIndex > -1 && (swapRecipe.toId !== swapRecipe.fromId)) {
        params.delete_cooking_recipe.push(item.recipe[cookIndex].id)
        item.recipe.splice(cookIndex,1)
        if(index !== swapRecipe.cookIndex) {
          const rIndex = item.recipe.findIndex(x=>x.recipe_id === swapRecipe.toId)
          if(rIndex === -1){
            params.cooking_data.push({
              cooking_date:item.cooking_date,
              recipes:[{
                recipe_id: swapRecipe.toId,
                side_dish_id: swapRecipe.sideDishId,
                serving_size: item.servingSize,
                isBundle : 0
              }]
            })
          }
        }
      } 
      return null
    })

    mealArr.map(item=>{
      item.recipe.map(rcp=>{
        if(rcp.isBundle === 0 && rcp.recipe_id === swapRecipe.fromId) {
          params.update_meal_schedule = [{
            id:rcp.id,
            recipe_id: swapRecipe.toId,
            side_dish_id: swapRecipe.sideDishId,
            serving_size: rcp.servingSize,
            isBundle: 0
          }]
          const ridIndex = recipeIds.findIndex(x=>x.id === swapRecipe.toId && x.type=== 'meal')
          if(ridIndex > -1) {
            recipeIds[ridIndex].size += rcp.servingSize
            recipeIds[ridIndex].count += 1
          }
          rcp.recipe.recipeIngredient = swapRecipe.recipe.recipeIngredient
          rcp.recipe.sideRecipe = swapRecipe.recipe.sideRecipe
          rcp.name = swapRecipe.recipe.name
          rcp.recipe.name = swapRecipe.recipe.name
          rcp.recipe.recipeImage = swapRecipe.recipe.recipeImage
          rcp.image = swapRecipe.recipe.recipeImage
          console.log(rcp, swapRecipe)
        }
        return null
      })
      return null;
    })
    this.setState({ mealArr, cookDay, loader: true, recipeIds})
    this.editPlan(params,'swap')
  }

  hideSwapModal() {
    const { showSwapRecipe } = this.state
    if(showSwapRecipe) {
      this.setState({ showSwapRecipe: false})
      setTimeout(()=> {
        this.setState({ showSwapModal: false, showSwapRecipe: true})
      },2000) 
    } else {
      this.setState({ showSwapModal: false, showSwapRecipe: true})
    }
    
  }

  

  /* authentication behaviour end */
  render() {
    // alert(this.props.location.pathname)
    const { 
      dayDates, reminder, subscriptionPlan, planType, editRecipe, groceryClass, dashClass, cookIndex, error, loader, 
      slideClass, notesMode, showNotesPopup, notesDate, notes, notesError, useFor,
      cardSlideClass, showBillingPopup, isMobile, inputs, showBuildPopup, showSwapModal
    } = this.state;
    // alert(useFor)
    
    const gClass = dashClass === 'active' ? 'dashActive' : ''
    const editRecipeClass = editRecipe ? `cal-days-cntnt dashboard-page  middle-cntnt btm-margn ${gClass}`: `cal-days-cntnt dishes-row  dashboard-page middle-cntnt ${cardSlideClass} ${gClass}`
    const errorClass = error ? 'crt-nw-pln' : '' 
    // let show = localStorage.getItem('newUser')
    const showBuild = (this.props.location.pathname === '/newUser' || (this.props.location.pathname === '/firstplanweek' && error)) && isMobile  
    // alert(error)
    if (!this.props.location.state && localStorage.type ==='checkUser') {
      localStorage.removeItem('token');
      return <Login location='/dashboard' />;
    }
    const cardPointerEvents = editRecipe ? 'none':'auto'
    return (
      <div className={`wrapper ${slideClass}`} >
        <title>
         Prep Day - {dashClass==='active' ? 'Dashboard' : 'Grocery List'}
        </title>
        <style>
          {`
          @media(min-width:320px) and (max-width:767px){
          .intercom-namespace .intercom-8kxdjc {
            bottom: 60px!important;
          }
          #PureChatWidget.purechat.purechat-image-only.purechat-widget-collapsed.purechat-bottom-right .purechat-collapsed-image, #PureChatWidget.purechat.purechat-image-only.purechat-widget-collapsed.purechat-top-right .purechat-collapsed-image{
            left:5px !important; right: auto !important;
          }
          #PureChatWidget.purechat.purechat-widget-collapsed{
            left: 20px important;
            right: auto !important;
            top: 15px !important;
          }
        }
          `}
        </style>
        {
          loader &&
              <div className="loading">
                <Loader />
                
                <div className="modal-backdrop fade in custm-bkdrp" />
              </div>
        }
        <DashHeader
          dashClass={this.state.dashClass}
          groceryClass={this.state.groceryClass}
          libraryClass="inactive"
          supportClass="inactive"
          dayDates={dayDates}
          subscriptionPlan={subscriptionPlan}
          previous={this.state.previous}
          planExist={planType}
          reminder={reminder}
          inputs={inputs}
          error={error}
          isMobile={isMobile}
          cookDay={this.state.cookDay}
          mealArr={this.state.mealArr}
          resetPln={()=>this.resetPlan()}
          useFor={useFor}
          buildPlan={(weekDate)=>this.createPlan(weekDate)}
          getWeekData={(dayDate, selectedWeek, previousDat)=>this.getWeekData(dayDate, selectedWeek, previousDat)}
        />
        { dashClass === 'active' && !error && !showBuild &&
              <div className="display-recipe-card mb-only dash-data">
                <span>
                  <button onClick={(event) => this.showCardList(event, 'vrt-chngs')} 
                    id="prep" 
                    className="recipe-card-view-btn" 
                    style={{'pointerEvents':cardPointerEvents}}>
                    {/* <img src="/images/lines.svg" alt="list"/> */}
                    Prep Plan
                  </button>
                  <button onClick={(event) => this.showCardList(event, '')} id="meal" style={{ 'pointerEvents':cardPointerEvents}}>
                    {/* <i className= "fa fa-image" /> */}
                    Meal Plan
                  </button>
                </span>
              </div>}
        <section className="select-meal-cntnt choose-recipe-cntnt">
          <div className={` nw-dash-cntnt ${errorClass}`}>
            <div className="container">
              <ReactResizeDetector handleWidth handleHeight onResize={() => this.onResize()} />
              
              {/* {showFeedbackPopup &&
                <div>
                  <FeedbackPopup 
                    submitFeedback={(data)=>this.submitFeedback(data)}
                    updateFeedback={(data)=>this.updateFeedback(data)}
                    removeFeedbackPopup={()=>this.removeFeedbackPopup()}
                    closeWelcomePopup={()=>this.closeWelcomePopup()}
                    popupType={popupType}
                  />
                  <div className="modal-backdrop fade in"/>
                </div>
              } */}
              {
                // add notes popup
              	showNotesPopup &&
               	<div>
               	  <NotesPopup 
               	    mode={notesMode} 
               	    notesDate={notesDate}
               	    notes={notes}
               	    notesError={notesError}
               	    cookIndex={cookIndex}
               	    onCancel={(data,mode)=>this.showNotes(data,mode)}
               	    onSave={(data,notesDte,mode, index)=>this.notesSave(data,notesDte, mode, index)}
               	    onDelete={(id, index)=>this.notesDelete(id, index)}
               	    closePopup = {()=>this.closePopup()}
                 	/>
                 	<div className="modal-backdrop fade in" onClick = {()=>this.closePopup()}/>
               	</div>
              }

              {
                ((groceryClass !=='active' &&
                  error && showBuildPopup && useFor !== 'sample') || (showBuild)) &&
                    <BuildNewPlan 
                      dayDates={dayDates}
                      createPlan={(weekDate)=>this.createPlan(weekDate)}
                      closeBuildPopup={()=>this.closeBuildPopup()}
                      isMobile={isMobile}
                    />
              }
              {
                showSwapModal &&
                this.swapModal()
              }
              
              <div className={editRecipeClass}>
                { groceryClass !=='active' ?                
                  isMobile ?
                    !error &&
                    <MobileRecipeData {...this.state}  
                      viewRecipe={(recipe, rname, sname, totalServing)=>this.viewDesktopRecipe(recipe, rname, sname, totalServing)}
                    />
                    :
                    <WeekRecipeData 
                      {...this.state} 
                      buildPlan={(weekDate, from)=>this.createPlan(weekDate, from)} 
                      showNotes= {(noteDate, mode, note, noteIndex)=>this.showNotes(noteDate, mode, note, noteIndex)} 
                      closePopup={(vRData) =>this.closeRecipePopup(vRData)}
                      removeServing={(index, size, vRData)=>this.removeServing(index, size, vRData)}
                      addServing={(index, size, vRData)=>this.addServing(index, size, vRData)}
                      editServing={(params, vRData)=>this.editServingSize(params, vRData)}
                      viewRecipe={(recipe, rname, sname, totalServing, vRData)=>this.viewDesktopRecipe(recipe, rname, sname, totalServing, vRData)}
                      deleteRecipe={(index, id, recipeId)=>this.deleteRecipe(index, id, recipeId)}
                      swapRecipe={(index)=>this.swapRecipe(index)}
                    />
                  :
                  <GroceryList 
                    dayDates={dayDates} 
                    {...this.state} 
                    buildNextWeekPlan={(weekDate)=>this.createPlan(weekDate)}
                  />
                }
              </div>
              

              { showBillingPopup &&
                <div>
                  <UpgradePlan 
                    onClose={()=>this.closeBillingPopup()}
                    dashClass={this.state.dashClass}
                    groceryClass={this.state.groceryClass}
                    dayDates={dayDates}
                    subscriptionPlan={subscriptionPlan}
                    previous={this.state.previous}
                  />
                  <div className="modal-backdrop fade in mb-only" style={{zIndex:'9'}}/>
                </div>
              }
              { isMobile  && 
              <DashboardBottom 
                editRecipe={editRecipe}
                // bottomText={bottomText}
                // mbClass={mbClass}
                onPressCancel={()=>this.onPressCancel()}
                onPressSave={(params, recipe, cDate)=>this.onPressSave(params, recipe, cDate)}
                // cookDayArr={cookDayArr}
                path="dashboard"
                dayDates={dayDates}
                groceryClass={groceryClass}
                dashClass={dashClass}
                // recipeArr={recipeArr}
                params = {inputs}
                // cookingDate = {cookingDate}
              />}
             
            </div>
          </div>
        </section>
            
      </div>
    );
  }
}

export default Dashboard;




// WEBPACK FOOTER //
// ./src/components/dashboard/Dashboard.js